import React from 'react';
import './App.css';

class App extends React.Component{

  constructor(props){
    super(props);
    this.state = {
      todoList:[],
      activeItem:{
        id:null,
        title:'',
        completed:false,
      },
      editing:false,
      showError:false
    }

    this.fetchTasks = this.fetchTasks.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.getCookie = this.getCookie.bind(this)

    this.startEdit = this.startEdit.bind(this)
    this.deleteItem = this.deleteItem.bind(this)
    this.strikeUnstrike = this.strikeUnstrike.bind(this)
  };


  getCookie(name) {
    let cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            // Does this cookie string begin with the name we want?
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
  }


  componentDidMount(){
    this.fetchTasks();
  }

  fetchTasks(){
    console.log('Fetching...');

    fetch('https://todo-api-01.herokuapp.com/api/task-list')
    .then(response => response.json())
    .then(data => {
        console.log("Before Reverse: ",data)
        this.setState({
          todoList:data
        })
        //console.log("After Reverse: ",this.state.todoList)
      })
      
  }

  handleChange(e){
    var name = e.target.name
    var value = e.target.value
    console.log('Name: ', name)
    console.log('Value: ', value)

    this.setState({
      activeItem:{
        ...this.state.activeItem,
        title:value
      }
    })
  }


  handleSubmit(e){
    e.preventDefault()
    console.log('ITEM', this.state.activeItem)

    if(this.state.activeItem.title !== ""){
      this.setState({
        showError:false
      })

      var csrftoken = this.getCookie('csrftoken')

      var url = 'https://todo-api-01.herokuapp.com/api/task-create/'
      
      if(this.state.editing === true){
          url = `https://todo-api-01.herokuapp.com/api/task-update/${this.state.activeItem.id}/`
          this.setState({
            editing:false
          })
      }


      fetch(url, {
        method:'POST',
        headers:{
          'Content-type':'application/json',
          'X-CSRFToken':csrftoken,
        },
        body:JSON.stringify(this.state.activeItem)
      }).then((response) => {
        this.fetchTasks()
        this.setState({
          activeItem:{
            id:null,
            title:'',
            completed:false,
          }
        })
      }).catch(function(error){
        console.log('ERORR:', error)
      })
    }else{
      //alert('Enter a task!')
      this.setState({
        showError:true
      })

      setTimeout(
        () => this.setState({ showError: false }), 
        4000
      );
    }

  }

  startEdit(task){

    if(this.state.editing === true && task.id === this.state.activeItem.id){
      this.setState({
        activeItem:{
          id:null,
          title:'',
          completed:false,
        },
        editing:false
      })
    }else{
      this.setState({
        activeItem:task,
        editing:true
      })
    }  
    

  }

  deleteItem(task){
    var csrftoken = this.getCookie('csrftoken')

    fetch(`https://todo-api-01.herokuapp.com/api/task-delete/${task.id}/`, {
      method: 'DELETE',
      headers: {
        'Content-type':'application/json',
        'X-CSRFToken': csrftoken,
      },
    }).then((response) => {
        this.fetchTasks()
    })

  }

  strikeUnstrike(task){
    task.completed = !task.completed
    var csrftoken = this.getCookie('csrftoken')
    var url = `https://todo-api-01.herokuapp.com/api/task-update/${task.id}/`

    fetch(url, {
      method: 'POST',
      headers:{
        'Content-type':'application/json',
        'X-CSRFToken':csrftoken,
      },
      body:JSON.stringify({'id':task.id, 'title':task.title, 'completed':task.completed})
    }).then((response) => {
        this.fetchTasks()
    })


    console.log('TASK: ', task.completed)
  }

  render(){
    var tasks = this.state.todoList;
    var self = this;

    return(
      <div className='container'>
          {self.state.showError === true ? (
              <div className="alert alert-danger alert-dismissible fade show" role="alert">
              <span><b>You must enter a Task to add!</b></span>
            </div>
          ) : (
            ""
          )}


        <div id="task-container">

          <div id="form-wrapper">
            <form onSubmit={this.handleSubmit} id='form'>
              <div className="flex-wrapper">

                <div style={{flex: 6}}>
                  <input onChange={this.handleChange}  className='form-control' id='title' type='text' value={this.state.activeItem.title} name='title' placeholder='Add Task' />
                </div>

                <div style={{flex: 1}}>
                  <input className='btn btn-warning' id='submit' type='submit' name='Add'/>
                </div>

              </div>
            </form>
          </div>
          <div className="list-wrapper">
            {tasks.map(function(task, index){
                return(
                  <div key={index} className="task-wrapper flex-wrapper">
                      <div onClick={() => self.strikeUnstrike(task)} style={{flex: 7}}>

                        {task.completed === false ? (
                            <span>{task.title}</span>
                        ) : (
                          <strike>{task.title}</strike>
                        )}
                        
                      </div>

                      <div style={{flex: 1}}>
                        <button onClick={() => self.startEdit(task)}  className='btn btn-sm btn-outline-info'>Edit</button>
                      </div>

                      <div style={{flex: 1}}>
                        <button onClick={() => self.deleteItem(task)}  className='btn btn-sm btn-outline-danger delete'>-</button>
                      </div>
                  </div>
                )
            })}
          </div>

        </div>

      </div>
    )
  }
}


export default App;
